<template>
  <div :class="{ 'admin-root': isAdmin }">
    <router-view :key="route.fullPath" />
  </div>
</template>

<style>
html, body {
  margin: 0;
  padding: 0;
}
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
    'WenQuanYi Micro Hei', 'Noto Sans CJK SC', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f5f5;
  min-height: 100vh;
}
/* 关键：button/input/textarea/select 默认 font-family: Arial，会绕过继承的中文字体 fallback
   显式 inherit 让它们走 #app 设置的跨平台字体链（这是大量"???"的根因） */
button, input, select, textarea, optgroup {
  font-family: inherit;
}
html:not(.admin-html),
html:not(.admin-html) body {
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
html:not(.admin-html)::-webkit-scrollbar,
html:not(.admin-html) body::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: none;
}
.admin-root {
  min-height: 100vh;
  background: #f4f6f9;
}
html.admin-html,
html.admin-html body,
html.admin-html #app {
  background: #f4f6f9;
  max-width: none;
}
</style>
<script setup>
import { computed, watch, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import { useTheme } from '@/composables/useTheme'
import { syncGameVisibility } from '@/data/games'
import { startGameConfigPush, stopGameConfigPush } from '@/composables/useGameConfigPush'

const route = useRoute()
const isAdmin = computed(() => route.path.startsWith('/admin'))
useTheme()

function syncLobbyConfig () {
  syncGameVisibility()
  startGameConfigPush()
}

function leaveLobbyConfig () {
  stopGameConfigPush()
}

watch(
  () => route.path,
  (path) => {
    if (path.startsWith('/admin')) {
      leaveLobbyConfig()
      return
    }
    syncLobbyConfig()
  },
  { immediate: true }
)

onUnmounted(() => {
  leaveLobbyConfig()
})
</script>